<script>
export default {
  functional: true,
  render: (h, { props }) => {
    const { actions } = props
    let actionList = actions.map((action, idx) => {
      const doAction = e => {
        e.preventDefault()
        e.stopPropagation()
        action.callBack()
      }
      let data = action.label
        ? <v-icon left>{action.icon}</v-icon>
        : <v-icon>{action.icon}</v-icon>
      return (
        <v-btn
          color={action.color}
          flat={action.isFlat}
          on-click={ doAction }
          key={idx}
        >
          { data }
          <span>{action.label}</span>
        </v-btn>
      )
    })

    return (
      <v-toolbar-items>
        { actionList }
      </v-toolbar-items>
    )
  },
}
</script>
